export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/access',
    /* internal name: '/access' */
    /* no component */
    children: [
      {
        path: '',
        name: '/access/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/access/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/accounts',
    /* internal name: '/accounts' */
    /* no component */
    children: [
      {
        path: '',
        name: '/accounts/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/accounts/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/autoreconciliations',
    /* internal name: '/autoreconciliations' */
    /* no component */
    children: [
      {
        path: '',
        name: '/autoreconciliations/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/autoreconciliations/index.vue'),
        /* no children */
      },
      {
        path: 'pending',
        name: '/autoreconciliations/pending',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/autoreconciliations/pending.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/businesspartners',
    /* internal name: '/businesspartners' */
    /* no component */
    children: [
      {
        path: 'client',
        name: '/businesspartners/client',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/businesspartners/client.vue'),
        /* no children */
      },
      {
        path: 'clients',
        name: '/businesspartners/clients',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/businesspartners/clients.vue'),
        /* no children */
      },
      {
        path: 'collaborators',
        name: '/businesspartners/collaborators',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/businesspartners/collaborators.vue'),
        /* no children */
      },
      {
        path: 'employee',
        name: '/businesspartners/employee',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/businesspartners/employee.vue'),
        /* no children */
      },
      {
        path: 'employees',
        name: '/businesspartners/employees',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/businesspartners/employees.vue'),
        /* no children */
      },
      {
        path: 'provider',
        name: '/businesspartners/provider',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/businesspartners/provider.vue'),
        /* no children */
      },
      {
        path: 'providers',
        name: '/businesspartners/providers',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/businesspartners/providers.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/changelog',
    /* internal name: '/changelog' */
    /* no component */
    children: [
      {
        path: '',
        name: '/changelog/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/changelog/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/company',
    /* internal name: '/company' */
    /* no component */
    children: [
      {
        path: '',
        name: '/company/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/company/index.vue'),
        /* no children */
      },
      {
        path: 'relation',
        name: '/company/relation',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/company/relation.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/creditcards',
    /* internal name: '/creditcards' */
    /* no component */
    children: [
      {
        path: 'add',
        name: '/creditcards/add',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/creditcards/add.vue'),
        /* no children */
      },
      {
        path: 'load',
        name: '/creditcards/load',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/creditcards/load.vue'),
        /* no children */
      },
      {
        path: 'loadCreditCardAccount',
        name: '/creditcards/loadCreditCardAccount',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/creditcards/loadCreditCardAccount.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/documents',
    /* internal name: '/documents' */
    /* no component */
    children: [
      {
        path: '',
        name: '/documents/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/documents/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/employees',
    /* internal name: '/employees' */
    /* no component */
    children: [
      {
        path: 'advanceWizard',
        name: '/employees/advanceWizard',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/advanceWizard.vue'),
        /* no children */
      },
      {
        path: 'employeeAdvanceCategoryInfo',
        name: '/employees/employeeAdvanceCategoryInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeAdvanceCategoryInfo.vue'),
        /* no children */
      },
      {
        path: 'employeeAdvanceConfirmation',
        name: '/employees/employeeAdvanceConfirmation',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeAdvanceConfirmation.vue'),
        /* no children */
      },
      {
        path: 'employeeAdvanceInfo',
        name: '/employees/employeeAdvanceInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeAdvanceInfo.vue'),
        /* no children */
      },
      {
        path: 'employeeAndSalaryWizard',
        name: '/employees/employeeAndSalaryWizard',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeAndSalaryWizard.vue'),
        /* no children */
      },
      {
        path: 'employeeBasicInfo',
        name: '/employees/employeeBasicInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeBasicInfo.vue'),
        /* no children */
      },
      {
        path: 'employeeCategoryInfo',
        name: '/employees/employeeCategoryInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeCategoryInfo.vue'),
        /* no children */
      },
      {
        path: 'employeeConfirmation',
        name: '/employees/employeeConfirmation',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeConfirmation.vue'),
        /* no children */
      },
      {
        path: 'employeeSalaryAdvanceCategoryInfo',
        name: '/employees/employeeSalaryAdvanceCategoryInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeSalaryAdvanceCategoryInfo.vue'),
        /* no children */
      },
      {
        path: 'employeeSalaryAdvanceConfirmation',
        name: '/employees/employeeSalaryAdvanceConfirmation',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeSalaryAdvanceConfirmation.vue'),
        /* no children */
      },
      {
        path: 'employeeSalaryAdvanceInfo',
        name: '/employees/employeeSalaryAdvanceInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeSalaryAdvanceInfo.vue'),
        /* no children */
      },
      {
        path: 'employeeSalaryInfo',
        name: '/employees/employeeSalaryInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/employeeSalaryInfo.vue'),
        /* no children */
      },
      {
        path: 'salaryAdvanceWizard',
        name: '/employees/salaryAdvanceWizard',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/salaryAdvanceWizard.vue'),
        /* no children */
      },
      {
        path: 'upload-employees',
        name: '/employees/upload-employees',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/employees/upload-employees.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/expenses',
    /* internal name: '/expenses' */
    /* no component */
    children: [
      {
        path: '',
        name: '/expenses/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/index.vue'),
        /* no children */
      },
      {
        path: 'createExpense',
        name: '/expenses/createExpense',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/createExpense.vue'),
        /* no children */
      },
      {
        path: 'createSalary',
        name: '/expenses/createSalary',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/createSalary.vue'),
        /* no children */
      },
      {
        path: 'createSpotExpense',
        name: '/expenses/createSpotExpense',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/createSpotExpense.vue'),
        /* no children */
      },
      {
        path: 'createSpotIncomeExpense',
        name: '/expenses/createSpotIncomeExpense',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/createSpotIncomeExpense.vue'),
        /* no children */
      },
      {
        path: 'createWage',
        name: '/expenses/createWage',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/createWage.vue'),
        /* no children */
      },
      {
        path: 'expenseAditional',
        name: '/expenses/expenseAditional',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseAditional.vue'),
        /* no children */
      },
      {
        path: 'expenseBasicInfo',
        name: '/expenses/expenseBasicInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseBasicInfo.vue'),
        /* no children */
      },
      {
        path: 'expenseBasicTaxInfo',
        name: '/expenses/expenseBasicTaxInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseBasicTaxInfo.vue'),
        /* no children */
      },
      {
        path: 'expenseCategory',
        name: '/expenses/expenseCategory',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseCategory.vue'),
        /* no children */
      },
      {
        path: 'expenseConfirmation',
        name: '/expenses/expenseConfirmation',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseConfirmation.vue'),
        /* no children */
      },
      {
        path: 'expenseList',
        name: '/expenses/expenseList',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseList.vue'),
        /* no children */
      },
      {
        path: 'expenseTaxAditional',
        name: '/expenses/expenseTaxAditional',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseTaxAditional.vue'),
        /* no children */
      },
      {
        path: 'expenseTaxCategory',
        name: '/expenses/expenseTaxCategory',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseTaxCategory.vue'),
        /* no children */
      },
      {
        path: 'expenseTaxWizard',
        name: '/expenses/expenseTaxWizard',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseTaxWizard.vue'),
        /* no children */
      },
      {
        path: 'expenseWizard',
        name: '/expenses/expenseWizard',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/expenseWizard.vue'),
        /* no children */
      },
      {
        path: 'incomeAditional',
        name: '/expenses/incomeAditional',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/incomeAditional.vue'),
        /* no children */
      },
      {
        path: 'incomeBasicInfo',
        name: '/expenses/incomeBasicInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/incomeBasicInfo.vue'),
        /* no children */
      },
      {
        path: 'incomeCategory',
        name: '/expenses/incomeCategory',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/incomeCategory.vue'),
        /* no children */
      },
      {
        path: 'incomeConfirmation',
        name: '/expenses/incomeConfirmation',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/incomeConfirmation.vue'),
        /* no children */
      },
      {
        path: 'incomeWizard',
        name: '/expenses/incomeWizard',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/incomeWizard.vue'),
        /* no children */
      },
      {
        path: 'loadSS',
        name: '/expenses/loadSS',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/loadSS.vue'),
        /* no children */
      },
      {
        path: 'salaryAditional',
        name: '/expenses/salaryAditional',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/salaryAditional.vue'),
        /* no children */
      },
      {
        path: 'salaryBasicInfo',
        name: '/expenses/salaryBasicInfo',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/salaryBasicInfo.vue'),
        /* no children */
      },
      {
        path: 'salaryCategory',
        name: '/expenses/salaryCategory',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/salaryCategory.vue'),
        /* no children */
      },
      {
        path: 'salaryWizard',
        name: '/expenses/salaryWizard',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/expenses/salaryWizard.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/fail',
    /* internal name: '/fail' */
    /* no component */
    children: [
      {
        path: '',
        name: '/fail/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/fail/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/gastos',
    /* internal name: '/gastos' */
    /* no component */
    children: [
      {
        path: '',
        name: '/gastos/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/gastos/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home',
    name: '/home',
    component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/home.vue'),
    /* no children */
  },
  {
    path: '/incomes',
    /* internal name: '/incomes' */
    /* no component */
    children: [
      {
        path: '',
        name: '/incomes/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/incomes/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/invoices',
    /* internal name: '/invoices' */
    /* no component */
    children: [
      {
        path: '',
        name: '/invoices/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/invoices/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/movements',
    /* internal name: '/movements' */
    /* no component */
    children: [
      {
        path: '',
        name: '/movements/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/movements/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/movements-all',
    /* internal name: '/movements-all' */
    /* no component */
    children: [
      {
        path: '',
        name: '/movements-all/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/movements-all/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/movementsAll',
    /* internal name: '/movementsAll' */
    /* no component */
    children: [
      {
        path: '',
        name: '/movementsAll/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/movementsAll/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/outcomes',
    /* internal name: '/outcomes' */
    /* no component */
    children: [
      {
        path: '',
        name: '/outcomes/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/outcomes/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/outinreconciliations',
    /* internal name: '/outinreconciliations' */
    /* no component */
    children: [
      {
        path: '',
        name: '/outinreconciliations/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/outinreconciliations/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/reconciliations',
    /* internal name: '/reconciliations' */
    /* no component */
    children: [
      {
        path: '',
        name: '/reconciliations/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/reconciliations/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/register',
    /* internal name: '/register' */
    /* no component */
    children: [
      {
        path: '',
        name: '/register/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/register/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/start',
    /* internal name: '/start' */
    /* no component */
    children: [
      {
        path: '',
        name: '/start/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/start/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/subscriptions',
    /* internal name: '/subscriptions' */
    /* no component */
    children: [
      {
        path: '',
        name: '/subscriptions/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/subscriptions/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/success',
    /* internal name: '/success' */
    /* no component */
    children: [
      {
        path: '',
        name: '/success/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/success/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/synchronizations',
    /* internal name: '/synchronizations' */
    /* no component */
    children: [
      {
        path: 'autoreconciliations',
        name: '/synchronizations/autoreconciliations',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/synchronizations/autoreconciliations.vue'),
        /* no children */
      },
      {
        path: 'movements',
        name: '/synchronizations/movements',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/synchronizations/movements.vue'),
        /* no children */
      },
      {
        path: 'sii',
        name: '/synchronizations/sii',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/synchronizations/sii.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/taxes',
    /* internal name: '/taxes' */
    /* no component */
    children: [
      {
        path: 'resume',
        name: '/taxes/resume',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/taxes/resume.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/terms-conditions',
    /* internal name: '/terms-conditions' */
    /* no component */
    children: [
      {
        path: '',
        name: '/terms-conditions/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/terms-conditions/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test',
    /* internal name: '/test' */
    /* no component */
    children: [
      {
        path: '',
        name: '/test/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/test/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/welcome',
    /* internal name: '/welcome' */
    /* no component */
    children: [
      {
        path: '',
        name: '/welcome/',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/index.vue'),
        /* no children */
      },
      {
        path: 'account-info',
        name: '/welcome/account-info',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/account-info.vue'),
        /* no children */
      },
      {
        path: 'aditional-info',
        name: '/welcome/aditional-info',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/aditional-info.vue'),
        /* no children */
      },
      {
        path: 'company-days',
        name: '/welcome/company-days',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/company-days.vue'),
        /* no children */
      },
      {
        path: 'company-info',
        name: '/welcome/company-info',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/company-info.vue'),
        /* no children */
      },
      {
        path: 'company-phone',
        name: '/welcome/company-phone',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/company-phone.vue'),
        /* no children */
      },
      {
        path: 'company-providers',
        name: '/welcome/company-providers',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/company-providers.vue'),
        /* no children */
      },
      {
        path: 'config-sync',
        name: '/welcome/config-sync',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/config-sync.vue'),
        /* no children */
      },
      {
        path: 'fail-process',
        name: '/welcome/fail-process',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/fail-process.vue'),
        /* no children */
      },
      {
        path: 'finish',
        name: '/welcome/finish',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/finish.vue'),
        /* no children */
      },
      {
        path: 'proximamente',
        name: '/welcome/proximamente',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/proximamente.vue'),
        /* no children */
      },
      {
        path: 'sii-info',
        name: '/welcome/sii-info',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/sii-info.vue'),
        /* no children */
      },
      {
        path: 'validate-company',
        name: '/welcome/validate-company',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/validate-company.vue'),
        /* no children */
      },
      {
        path: 'validate-email',
        name: '/welcome/validate-email',
        component: () => import('/builds/vecti/payments/packages/apps/Payments/frontend/src/pages/welcome/validate-email.vue'),
        /* no children */
      }
    ],
  }
]
